import { Request } from '~src/httpClient/serverApi/requests/Request';
import { IResult } from '~src/httpClient/serverApi/types/IResponse';

export interface ILogoutResult extends IResult {
  redirectUrl: string;
}

export class LogoutRequest extends Request<{}, ILogoutResult> {
  constructor() {
    super('logout', {});
  }
}
